import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading || user === null) {
    return (
      <div className="flow-bg min-h-screen flex items-center justify-center" data-testid="auth-loading">
        <div className="flex items-end gap-1 h-8">
          {[0, 1, 2, 3, 4].map((i) => <span key={i} className="w-1 h-full rounded-full bg-[var(--accent)] wave-bar" style={{ animationDelay: `${i * 120}ms` }} />)}
        </div>
      </div>
    );
  }
  if (!user) {
    sessionStorage.setItem("mulankan_after_login", loc.pathname + loc.search);
    return <Navigate to="/login" replace />;
  }
  return children;
}
